import * as React from "react";
import type { SVGProps } from "react";
const SvgUserCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 12.75A4.375 4.375 0 1 0 12 4a4.375 4.375 0 0 0 0 8.75m0-1.5a2.875 2.875 0 1 0 0-5.75 2.875 2.875 0 0 0 0 5.75"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.633 20.439A10 10 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10a9.99 9.99 0 0 1-4.634 8.44 7.4 7.4 0 0 1-1.84.92A10 10 0 0 1 12 22a10 10 0 0 1-3.524-.639 7.4 7.4 0 0 1-1.843-.922m2.363-.485c.853.291 1.878.47 3.004.47s2.152-.179 3.005-.47a8.5 8.5 0 0 0 1.537-.768c.74-.534.958-1.06.958-1.411 0-.403-.285-1.033-1.315-1.644-.998-.592-2.474-1.006-4.185-1.006s-3.187.414-4.185 1.006c-1.03.61-1.315 1.24-1.315 1.644 0 .352.217.877.958 1.41q.725.46 1.538.769m-3.873-2.957c.614-1.92 3.46-3.372 6.877-3.372s6.263 1.452 6.877 3.372a8.5 8.5 0 1 0-13.754 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUserCircle;
